const BURNING_STAR_ITEMS = [
  { x: 6, y: 5, scale: 0.7, delay: 0 },
  { x: 18, y: 12, scale: 0.9, delay: 180 },
  { x: 30, y: 1, scale: 0.75, delay: 340 },
  { x: 44, y: 11.5, scale: 1, delay: 520 },
  { x: 88, y: 28, scale: 0.8, delay: 760 },
  { x: 72, y: 13, scale: 0.92, delay: 980 },
  { x: 84, y: 6, scale: 0.7, delay: 1210 },
  { x: 12, y: 22, scale: 0.95, delay: 460 },
  { x: 10, y: 38, scale: 0.86, delay: 250 },
  { x: 54, y: 33, scale: 0.72, delay: 640 },
  { x: 10, y: 52, scale: 0.88, delay: 790 },
  { x: 24, y: 58, scale: 0.76, delay: 1120 },
  { x: 38, y: 50, scale: 1, delay: 330 },
  { x: 52, y: 60, scale: 0.82, delay: 690 },
  { x: 66, y: 53, scale: 0.72, delay: 980 },
  { x: 80, y: 59, scale: 0.9, delay: 1240 },
  { x: 92, y: 47, scale: 0.68, delay: 1540 },
];

function BurningStarIcon({ glowColor }) {
  return (
    <svg width="34" height="47" viewBox="0 0 34 47" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M11.3042 22.969C15.0306 22.969 15.9622 12.9721 15.9622 10C15.9622 21.7531 26.8309 22.969 22.1729 22.969C17.5149 22.969 15.9622 44.0436 15.9622 33.9116C15.9622 23.7796 6.64624 22.969 11.3042 22.969Z"
        fill={glowColor}
        fillOpacity="0.9"
      />
      <path
        d="M12.6449 23.0598C15.4397 23.0598 16.1384 15.5621 16.1384 13.333C16.1384 22.1479 24.2899 23.0598 20.7964 23.0598C17.3029 23.0598 16.1384 38.8657 16.1384 31.2667C16.1384 23.6677 9.15143 23.0598 12.6449 23.0598Z"
        fill="white"
      />
    </svg>
  );
}

export default function BurningStarField({ glowColor = 'rgba(255, 42.66, 240.84, 0.40)' }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-[1] overflow-hidden">
      {BURNING_STAR_ITEMS.map((item, index) => (
        <div
          key={`${item.x}-${item.y}-${index}`}
          className="punch-burning-field-star absolute -translate-x-1/2 -translate-y-1/2"
          style={{
            left: `${item.x}%`,
            top: `${item.y}%`,
            transform: `translate(-50%, -50%) scale(${item.scale})`,
            animationDelay: `${item.delay}ms`,
            filter: `drop-shadow(0 0 8px ${glowColor})`,
          }}
        >
          <BurningStarIcon glowColor={glowColor} />
        </div>
      ))}
    </div>
  );
}
